module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG0007-9f2b76200dff780936ded7b416823390.png";